// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const MenuContainer = styled.div `
  .menu-v2 {
    --main-menu-size: 48px;
    --main-menu-padding: 20px;
  }
`;
//# sourceMappingURL=style.js.map